define('MM/Models/ContentSearch/FacetCascadedValue',["knockout", "score_bootstrap/Models/SitecoreId"], function (ko, SitecoreId) {
    "use strict";

    function FacetCascadedValue(id, value, parent, text, rowElement, isPreselected, isDisabled) {
        var self = this;

        this.id = SitecoreId.parse(id);
        this.value = value;
        this.parent = parent;
        this.text = text;
        this.selected = ko.observable(isPreselected);
        this.count = ko.observable(0);

        this.disabled = ko.observable(isDisabled);
        //= ko.computed(function () {
        //    if (self.selectedParent) {
        //        return self.count() === 0 || self.parent !== self.selectedParent;
        //    }
        //    return self.count() === 0;
        //});

        this.resetCount = function () {
            this.count(0);
        };

        this.selectedParent = "";

        ko.applyBindings(this, rowElement);
    }

    return FacetCascadedValue;
});
